import type { Company } from '@app/types/Company';
import { ActivitySectorPM } from '@app/models/api/enums/ActivitySectorEnum';
import { error } from '@sveltejs/kit';
import { get } from 'svelte/store';
import { t } from 'svelte-i18n';

export const getCompanyInfoBySIRET = async (siret: string): Promise<Company> => {
	const $t = get(t);
	if (siret.length !== 14) {
		error(500, { message: $t('incorrectNumberOfCharacters') });
	}

	const fetchCompanyData = async (): Promise<Response> => fetch(`/company?siret=${siret}`);

	let res = await fetchCompanyData();
	if (res.status === 401) {
		res = await fetchCompanyData();
	}

	const responseJson = await res?.json();
	if (!res?.ok || !responseJson?.etablissements) {
		error(500, { message: responseJson?.message || $t('callError') });
	}

	const establishment = responseJson.etablissements[0];
	const unitLegal = establishment?.uniteLegale;

	const codeNaf = unitLegal?.activitePrincipaleUniteLegale?.split('.')[0];
	const businessLine = codeNaf
		? Object.keys(ActivitySectorPM).find((key) => key.endsWith(codeNaf))
		: null;

	const companyName =
		unitLegal?.denominationUniteLegale ||
		(unitLegal?.nomUniteLegale && unitLegal?.prenom1UniteLegale
			? `${unitLegal.nomUniteLegale} ${unitLegal.prenom1UniteLegale}`
			: undefined);

	return {
		businessLine,
		name: companyName,
		siret: establishment?.siret,
		siren: establishment?.siren,
		cityOfRegistration: establishment?.adresseEtablissement?.libelleCommuneEtablissement,
		postalCode: establishment?.adresseEtablissement?.codePostalEtablissement,
		dateCreation: unitLegal?.dateCreationUniteLegale,
		address:
			`${establishment?.adresseEtablissement?.numeroVoieEtablissement} ` +
			`${establishment?.adresseEtablissement?.typeVoieEtablissement} ` +
			`${establishment?.adresseEtablissement?.libelleVoieEtablissement} ` +
			`${establishment?.adresseEtablissement?.codePostalEtablissement} ` +
			`${establishment?.adresseEtablissement?.libelleCommuneEtablissement}`.trim()
	};
};
